<div class="d-flex row align-items-center flex-nowrap">
    @if (extendedInfoCard.avatars?.length) {
        <molecule-avatar-group-container
            class="divider-end"
            [size]="size"
            [avatars]="extendedInfoCard.avatars"
            [fixedWidth]="fixedWidthAvatarsAndIcons"
            [forceGroup]="false"
        ></molecule-avatar-group-container>
    }
    @if (extendedInfoCard.icon && !extendedInfoCard.avatars?.length) {
        <div
            class="avatar-group avatar-group--{{ size }} divider-end"
            [class.avatar-group--fixed-width]="fixedWidthAvatarsAndIcons"
        >
            <wdx-icon
                class="icon-container d-flex justify-content-center align-items-center rounded-circle bg-icon icon-container-size-lg"
                [icon]="extendedInfoCard.icon"
                [scale]="1.25"
            ></wdx-icon>
        </div>
    }
    <molecule-info-card
        class="flex-grow-1 text-truncate"
        data-cy="info-card"
        [primaryInfo]="extendedInfoCard.infoCard?.primaryInfo"
        [secondaryInfo]="extendedInfoCard.infoCard?.secondaryInfo"
        [tertiaryInfo]="extendedInfoCard.infoCard?.tertiaryInfo"
        [routerLinkData]="extendedInfoCard.infoCard?.routerLink"
        [openInNewTab]="extendedInfoCard.infoCard?.openInNewTab"
        [entityType]="extendedInfoCard.infoCard?.entityType"
        [entityId]="extendedInfoCard.infoCard?.entityId"
        [formSetup]="extendedInfoCard.infoCard?.formSetup"
        [showEditForm]="extendedInfoCard.infoCard?.showEditForm"
        (linkClicked)="onLinkClicked()"
    ></molecule-info-card>

    @if (extendedInfoCard.secondaryAvatars?.length) {
        <molecule-avatar-group-container
            [size]="'md'"
            [avatars]="extendedInfoCard.secondaryAvatars"
            [fixedWidth]="fixedWidthAvatarsAndIcons"
            [forceGroup]="false"
        ></molecule-avatar-group-container>
    }

    @for (tile of extendedInfoCard.tiles; track $index; let i = $index) {
        <div
            class="flex-shrink-0 d-none justify-content-center col-2 d-sm-flex"
            [ngClass]="{ 'divider-end': i < extendedInfoCard.tiles.length - 1 }"
        >
            <molecule-tile-mini [tile]="tile"></molecule-tile-mini>
        </div>
    }

    @if (showButtons) {
        <div class="d-flex ms-2 align-items-center">
            @if (icon) {
                <div class="d-none d-sm-flex">
                    <wdx-icon
                        class="me-2"
                        [icon]="icon"
                        [hidden]="!extendedInfoCard.isMine"
                    ></wdx-icon>
                </div>
            }
            @for (button of buttons; track $index) {
                <div class="d-none d-sm-flex">
                    @if (button.mode === ACTION_BUTTONS_MODE.FavouriteButton) {
                        <wdx-toggle-button
                            class="me-2"
                            size="sm"
                            [toggle]="extendedInfoCard.isFavourite"
                            (wdxOnChange)="onToggleFavourite($event)"
                        ></wdx-toggle-button>
                    }
                </div>
            }
            @if (extendedInfoCard?.actionButton) {
                <molecule-action-button
                    [actionButton]="extendedInfoCard.actionButton"
                    size="sm"
                    [hideDropdownChevron]="true"
                    (selectMenuItem)="onMenuItemSelected($event)"
                >
                </molecule-action-button>
            }
        </div>
    }

    <ng-content></ng-content>
</div>
